import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { GetUrl } from "../config/GetUrl";

export const staticContentApi = createApi({
    reducerPath: "staticContentApi",
    baseQuery: fetchBaseQuery({
        baseUrl: GetUrl.API_URL,
    }),
    endpoints: (builder) => ({
        GetStaticContentByType: builder.query({
            query: (type) => ({
                url: `/api/v1/Admin/getCms?type=${type}`,
                method: "GET",
            }),
        }),
        UpdateStaticContent: builder.mutation({
            query: (result) => ({
                url: `/api/v1/Admin/addedCms`,
                method: "PUT",
                body: result,
                headers: {
                    authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
                },

            }),
        }),

    }),
});

export const {
    useUpdateStaticContentMutation,
    useGetStaticContentByTypeQuery,
} = staticContentApi;
